import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import CompanyStatusCheck from "./CompanyStatusCheck";
import moment from "moment";
import Search from "./Search";

import Index from "./Index";
import { fetchEmailBroadcastEmails } from "../actions/index";

export class EmailBroadcastEmailsIndex extends Index {
  static propTypes = {
    fetchEmailBroadcastEmails: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    emails: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.email = null;
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchEmailBroadcastEmails(
      this.props.match.params.id,
      this.serialize(newQueries)
    );
    this.props.history.push(`/eblasts/${this.props.match.params.id}/emails${this.serialize(newQueries)}`);
  }

  hasBeenDelivered(email) {
    if (
      email.delivered_count > 0 ||
      email.opened_count > 0 ||
      email.clicked_count > 0 ||
      email.unsubscribed_count > 0 ||
      email.complained_count > 0
    ) {
      return 1;
    } else {
      return 0;
    }
  }

  renderEmailBroadcasts() {
    if (!this.props.emails.data) {
      return (
        <tr>
          <td colSpan={10}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.emails.data.length == 0) {
      return (
        <tr>
          <td colSpan={10}>
            <div className="well well-lg text-center">
              You have no emails.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.emails.data.map(email => {
      return (
        <tr key={email.id}>
          <td>{moment(email.created_at).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td>{email.to}</td>
          <td className="text-right">{this.hasBeenDelivered(email)}</td>
          <td className="text-right">{email.opened_count}</td>
          <td className="text-right">{email.clicked_count}</td>
          <td className="text-right">{email.unsubscribed_count}</td>
          <td className="text-right">{email.complained_count}</td>
          <td className="text-right">{email.bounced_count}</td>
          <td className="text-right">{email.dropped_count}</td>
          <td className="text-right">
            <Link
              to={`/sent_emails/${ email.id }`}
              className="btn btn-xs btn-inverse pull-right"
            >
              Details
            </Link>
          </td>
        </tr>
      );
    });
  }

  startTour() {
    this.setState({
      steps: [
        {
          content: "The eBlasts page lists the eBlasts you have created.",
          target: ".help_icon_smaller",
          placement: "bottom",
          disableBeacon: true
        }
      ],
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (!this.props.emails.meta) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    if (this.props.emails.meta) {
      count = this.props.emails.meta.count;
    }
    return (
      <div className="emails_index">
        <CompanyStatusCheck history={this.props.history} />
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            eBlast Emails
            <button
              bsStyle="default"
              className="btn btn-sm btn-primary help_icon_smaller"
              onClick={this.startTour.bind(this)}
            >
              ?
            </button>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`email_date ${this.indicateSorting("created_at")}`}
                >
                  Sent Date
                </th>
                <th
                  className={`email_to ${this.indicateSorting(
                    "sent_emails.to"
                  )}`}
                >
                  To
                </th>
                <th
                  className={`text-right email_stats_sent ${this.indicateSorting(
                    "delivered_count"
                  )}`}
                >
                  Delivered
                </th>
                <th
                  className={`text-right email_stats_opened ${this.indicateSorting(
                    "opened_count"
                  )}`}
                >
                  Opens
                </th>
                <th
                  className={`text-right email_stats_clicked ${this.indicateSorting(
                    "clicked_count"
                  )}`}
                >
                  Clicks
                </th>
                <th
                  className={`text-right email_stats_unsubscribed ${this.indicateSorting(
                    "unsubscribed_count"
                  )}`}
                >
                  Unsubs
                </th>
                <th
                  className={`text-right email_stats_spam_report ${this.indicateSorting(
                    "complained_count"
                  )}`}
                >
                  Spam R.
                </th>
                <th
                  className={`text-right email_stats_bounced ${this.indicateSorting(
                    "bounced_count"
                  )}`}
                >
                  Bounces
                </th>
                <th
                  className={`text-right email_stats_failed ${this.indicateSorting(
                    "dropped_count"
                  )}`}
                >
                  Failures
                </th>
              </tr>
            </thead>
            <tbody>{this.renderEmailBroadcasts()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { emails: state.emailBroadcasts.emails };
}

export default connect(
  mapStateToProps,
  { fetchEmailBroadcastEmails }
)(EmailBroadcastEmailsIndex);
